import React, { forwardRef } from 'react';
import { StepDescriptionWrapper } from './subcomponents';
const Step = forwardRef(({ stepData, dataCy, placement }, ref) => {
    return (React.createElement(StepDescriptionWrapper, { "data-cy": dataCy, "$placement": placement, ref: ref }, stepData));
});
export default Step;
